import React from "react";
import l from "components/util/l";
import View from "components/vmisc/executions/Executions.view";
import 'moment/locale/es';

function Executions({
  flow = {},
  showDebugOnly = false,
  isAdmin = false,
  styles = {},
  title = l("Ejecuciones%VC029"),
  refetchExecutions = () => { },
}) {
  return <View
    flow={flow}
    styles={styles}
    title={title}
    showDebugOnly={showDebugOnly}
    isAdmin={isAdmin}
    refetchExecutions={refetchExecutions}
  />
}

export default Executions;